import Model from './Model'

export default interface Admin extends Model {
	fullname: string
	firstname: string
	lastname: string
	email: string
	phone: string
	role: Role
	designation?: {
		id: number
		slug: string
		title: string
		type: string
		address?: string
	}
	association?: Association
	financier?: Financier
	workplace?: {
		title: string
		slug?: string
		type?: string
	}
}

export interface Association {
	id: number
	admin_id: number
	financier_id: number
	admin?: Admin
	financier?: Financier
}

export interface Financier {
	id: number
	title: string
	email: string
	phone: string
}

export enum Role {
	SUPER_ADMIN = 'super_admin',
	COUNTRY_MANAGER = 'country_manager',
	REGIONAL_MANAGER = 'regional_manager',
	STATE_MANAGER = 'state_manager',
	ZONAL_MANAGER = 'zonal_manager',
	CLUSTER_MANAGER = 'cluster_manager',
	STATION_MANAGER = 'station_manager',
	STATION_OFFICER = 'station_officer',
	WAREHOUSE_MANAGER = 'warehouse_manager',
	FINANCIER = 'financier',
}

export interface Roles {
	name: string
	value: string
}

export function hasRole(admin: Admin, roles: Role | Role[]) {
	if (!admin) return false
	return roles instanceof Array ? roles.includes(admin.role) : admin?.role === roles
}
